import Promise from 'promise';
import abortable from './utils/abortable';

const never = new Promise(() => {});

export default function makeAbortable(_promise, _abortable = abortable()) {
  const {abort, isAborted} = _abortable;

  const promise = Promise.resolve(_promise).finally(() => {
    if (isAborted()) return never;
    return void 0;
  });

  return {abort, isAborted, promise};
}



// WEBPACK FOOTER //
// ./abortable-promise.jsx